






import { Component, Prop, Vue } from "vue-property-decorator";
import { bus } from "@/bus";
// service methods
import { getExtension } from "@/services/customExtensions/customExtensionService";
// types
import { CustomExtension, Param } from "@/services/customExtensions/types";
import { AclMember } from "@/services/security/types";

@Component
export default class CustomExtensionRender extends Vue {
    @Prop() customExtensionId!: string;

    customExtension = {
        id: "",
        name: "",
        menuText: "",
        menuIconFileId: "",
        url: "",
        params: [] as Array<Param>,
        acl: [] as Array<AclMember>
    } as CustomExtension;

    iframeHeight = "800px"; // Default height, will be adjusted

    // lifecycle hooks
    public created(): void {
        this.fetchData();
        bus.$on("reload", () => {
            this.fetchData();
        });
    }

    mounted() {
        // disable body scroll when the component is mounted to prevent scroll appearing on the load for few frames.
        document.body.classList.add("no-body-scroll");
    }

    beforeDestroy() {
        document.body.classList.remove("no-body-scroll");
        bus.$off("reload");
    }

    // methods & actions
    fetchData() {
        if (this.customExtensionId) {
            getExtension(this.customExtensionId ? this.customExtensionId : this.customExtension.id).then(response => {
                this.customExtension = response;
            });
        }
    }
}
